import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Button, Callout, Card, Elevation, Spinner,
} from '@blueprintjs/core';
import { autobind } from 'core-decorators';

import { handleCallback, login } from 'auth/authkit';
import { authkitSession } from 'actions/user';
import { history } from 'store/configureStore';

// Landing page for the AuthKit redirect: exchanges the authorization code for
// tokens, stores the session, and returns to wherever login started.
class AuthCallback extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
    };
  }

  componentDidMount() {
    const { dispatch } = this.props;
    handleCallback(window.location.search)
      .then(({ token, returnTo }) => {
        dispatch(authkitSession(token));
        history.replace(returnTo);
      })
      .catch((error) => {
        this.setState({ error: error.message });
      });
  }

  @autobind
  retry() {
    return login('/');
  }

  render() {
    const { error } = this.state;
    if (!error) {
      return (
        <div style={{ paddingTop: 50 }}>
          <Spinner size={100} />
        </div>
      );
    }
    return (
      <section className="hero is-fullheight">
        <div className="hero-body">
          <div className="container has-text-left">
            <div className="columns">
              <div className="column is-one-third is-offset-one-third">
                <Card elevation={Elevation.FOUR}>
                  <Callout intent="danger" title="Sign-in failed">
                    {error}
                  </Callout>
                  <br />
                  <Button intent="success" fill onClick={this.retry}>
                    Try again
                  </Button>
                </Card>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

AuthCallback.propTypes = {
  dispatch: PropTypes.func,
};

export default connect()(AuthCallback);
